var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.25 9.65004C20.76 8.87004 20.2 8.17004 19.62 7.54004L15.85 11.31C15.97 11.68 16.04 12.08 16.04 12.5C16.04 14.74 14.23 16.54 12 16.54C11.58 16.54 11.18 16.47 10.81 16.35L7.34998 19.81C8.80998 20.63 10.39 21.06 12 21.06C13.78 21.06 15.51 20.54 17.09 19.57C18.67 18.59 20.09 17.16 21.25 15.34C22.25 13.78 22.25 11.22 21.25 9.65004Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 10.4796L9.98001 14.5196C9.47001 13.9996 9.14001 13.2796 9.14001 12.4996C9.14001 10.9296 10.42 9.63965 12 9.63965C12.78 9.63965 13.5 9.96965 14.02 10.4796Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.25 6.24969L14.86 9.63969C14.13 8.89969 13.12 8.45969 12 8.45969C9.76 8.45969 7.96 10.2697 7.96 12.4997C7.96 13.6197 8.41 14.6297 9.14 15.3597L5.76 18.7497H5.75C4.64 17.8497 3.62 16.6997 2.75 15.3397C1.75 13.7697 1.75 11.2197 2.75 9.64969C3.91 7.82969 5.33 6.39969 6.91 5.41969C8.49 4.45969 10.22 3.92969 12 3.92969C14.23 3.92969 16.39 4.74969 18.25 6.24969Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 12.5001C14.86 14.0701 13.58 15.3601 12 15.3601C11.94 15.3601 11.89 15.3601 11.83 15.3401L14.84 12.3301C14.86 12.3901 14.86 12.4401 14.86 12.5001Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.77 2.72988C21.47 2.42988 20.98 2.42988 20.68 2.72988L2.23 21.1899C1.93 21.4899 1.93 21.9799 2.23 22.2799C2.38 22.4199 2.57 22.4999 2.77 22.4999C2.97 22.4999 3.16 22.4199 3.31 22.2699L21.77 3.80988C22.08 3.50988 22.08 3.02988 21.77 2.72988Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.527ff9ad107e91080ae8d15c8d84ce06.svg";
export { ForwardRef as ReactComponent };